import React, { useState } from "react";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppBarComponent from "../../components/Structure/LayoutComponents/Appbar/AppBarComponent";
import SidebarComponent from "../../components/Structure/LayoutComponents/SideBar/SidebarComponent";
import { usePatientModal } from "../../context/PatientModalContext/PatientModalContext";
import LayPatientModal from "../../components/Advanced/Modal/LayPatientModal/LayPatientModal";
import ObservationsModal from "../../components/Advanced/Modal/ObservationsModal/ObservationsModal";
import { ViewAsRoleProvider } from "../../context/ViewAsRoleContext/ViewAsRoleContext";
import MfaLowCodesBanner from "../../components/Structure/MfaLowCodesBanner";
import {
  AlertsProvider,
  AlertsDrawer,
  LoginUnsignedNotesDialog,
} from "../../modules/shared/alerts";

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [WidthDrawDate, setWidthDrawDate] = useState(240);

  const { open, selectedPatientId, closeModal } = usePatientModal();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleOpenNavMenu = () => {
    setMobileOpen(true);
  };

  return (
    <ViewAsRoleProvider>
      <AlertsProvider>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBarComponent
          handleOpenNavMenu={handleOpenNavMenu}
          WidthDrawDate={WidthDrawDate}
        />
        <SidebarComponent
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          WidthDraw={(width) => setWidthDrawDate(width)}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { md: `calc(100% - ${WidthDrawDate}px)` },
            transition: "width 0.3s ease",
          }}
        >
          <Toolbar />
          <MfaLowCodesBanner />
          <Outlet />
        </Box>

        <LayPatientModal
          open={open}
          onClose={closeModal}
          selectedPatientId={selectedPatientId}
        />

        <ObservationsModal />

        {/* Panel lateral derecho de notificaciones + dialog de login con las
            notas clínicas sin firmar en AdvancedMD.
            DEV-ONLY: ambos (y la campana del AppBar) se autogatean con
            ALERTS_ENABLED y no renderizan nada en producción mientras los
            datos sean mock — ver modules/shared/alerts/constants.js */}
        <AlertsDrawer />
        <LoginUnsignedNotesDialog />
      </Box>
      </AlertsProvider>
    </ViewAsRoleProvider>
  );
};

export default Layout;
